// import React, { useEffect, useState } from "react";
// import AdminCollectionPage from "./Admincollectionpage";
// import ChaserCollectionPage from "./Chasercollectionpage";
// import ExecutivePage from "./ExecutiveData";
// import api from "../../service/CommonService";

// const TARGET_COMPONENT_ID = "EMOBCE0004";

// export default function DailyCollectionSheet() {
//   const [accessLevel, setAccessLevel] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     api
//       .GetAccessHeadComponent()
//       .then((res) => {
//         const list = res.data?.ResultSet ?? [];

//         const row = list.find(
//           (x) => x?.ComponentId === TARGET_COMPONENT_ID
//         );

//         setAccessLevel(
//           row?.AccessLevel != null ? String(row.AccessLevel) : ""
//         );
//       })
//       .catch((err) => {
//         console.error("Access level fetch failed", err);
//         setAccessLevel("");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   switch (accessLevel) {
//     case "1":
//       return <ChaserCollectionPage />;

//     case "2":
//       return <ExecutivePage />;

//     default:
//       return <AdminCollectionPage />;
//   }
// }

import React, { useEffect, useState } from "react";
import AdminCollectionPage from "./Admincollectionpage";
import ChaserCollectionPage from "./Chasercollectionpage";
import ExecutivePage from "./ExecutiveData";
import api from "../../service/CommonService";

const TARGET_COMPONENT_ID = "EMOBCE0004";

export default function DailyCollectionSheet() {
  const [accessLevel, setAccessLevel] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .GetAccessHeadComponent()
      .then((res) => {
        const list = res.data?.ResultSet ?? [];

        const row = list.find(
          (x) => x?.ComponentId === TARGET_COMPONENT_ID
        );

        setAccessLevel(
          row?.AccessLevel != null ? String(row.AccessLevel) : ""
        );
      })
      .catch((err) => {
        console.error("Access level fetch failed", err);
        setAccessLevel("");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  switch (accessLevel) {
    case "1":
      return <ChaserCollectionPage />;

    case "2":
      return <ExecutivePage />;

    default:
      return <AdminCollectionPage />;
  }
}